import Vue from 'vue';
import 'vue-use-vuex';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueBus from 'vue-bus';
import VueJWT from 'vuejs-jwt';
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import VueMatomo from 'vue-matomo';
import Vuex from 'vuex';
import { VueMaskDirective } from 'v-mask';

// import VueSocketIO from 'vue-socket.io';

import vuetify from '@/plugins/Vuetify';
import App from '@/App';
import router from '@/router';
import store from '@/store';

import VueCountdownTimer from 'vuejs-countdown-timer';
import VueCurrencyInput from 'vue-currency-input';
import VueCurrencyFilter from 'vue-currency-filter';
import TranslationService from './services/TranslationService';
import consts from './static/js/consts';
import events from './static/js/events';

import translations from './locales';

import './plugins/Filters';

import interceptorsSetup from './static/js/interceptors';

const registerConsts = Object.defineProperty(Vue.prototype, '$consts', {
  get() {
    return consts;
  },
});

const registerEvents = Object.defineProperty(Vue.prototype, '$events', {
  get() {
    return events;
  },
});

if (window.DM_ENV && window.DM_ENV.MATOMO_HOST) {
  const matomoConfig = {
    host: window.DM_ENV.MATOMO_HOST || '',
    siteId: window.DM_ENV.MATOMO_SITE_ID || '',
    router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    trackerFileName: window.DM_ENV.MATOMO_TRACKER || '',
    debug: window.DM_ENV.MATOMO_DEBUG || '',
  };
  Vue.use(VueMatomo, matomoConfig);
}

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VueBus);
Vue.use(VueI18n);
Vue.use(VueJWT);
Vue.use(Vuelidate);

Vue.use(registerConsts);
Vue.use(registerEvents);

Vue.use(VueCurrencyInput);

Vue.use(VueCountdownTimer);

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;

interceptorsSetup();
/*
Vue.use(new VueSocketIO({
  debug: true,
  connection: consts.ENDPOINTS.SOCKETIO,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_',
  },
}));
*/

Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
  });

const i18n = TranslationService.initI18n(translations, 'en');

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
